// @ts-nocheck
import { useState, useRef, useReducer, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Divider } from 'primereact/divider';
import { ScrollPanel } from 'primereact/scrollpanel';
import { TimeSetOption } from './EnviromentInfo/TimeSetOption';
import { CloudSetOption } from './EnviromentInfo/CloudSetOption';
import { LightningEntityOption } from './EnviromentInfo/LightningEntityOption';
import "../assets/functionalComponents/_dialog.scss"
import "../assets/functionalComponents/_dataItem.scss"
import "../assets/functionalComponents/ScrollPanelDemo.css"

const EnviromentOption = (props) => {

    const [enviromentList, setEnviromentList] = useState([]);
    const [timeEventList, setTimeEventList] = useState([[]]);
    const [lastList, setLastList] = useState([]);
    const [showAllLightning, setShowAllLightning] = useState(null);

    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [indexNum, setIndexNum] = useState("");
    const [, forceUpdate] = useReducer(num => num + 1, 0);

    const [LightningEntity, setLightningEntity] = useState(false);
    const [reChange, setReChange] = useState(false);
    const [entityLatitude, setEntityLatitude] = useState("");
    const [entityLongitude, setEntityLongitude] = useState("");
    const [entityHeight, setEntityHeight] = useState("");
    const [entityEndHeight, setEntityEndHeight] = useState("");
    const [entityPeriod, setEntityPeriod] = useState("");
    const [entityRGBWeightR, setEntityRGBWeightR] = useState("");
    const [entityRGBWeightG, setEntityRGBWeightG] = useState("");
    const [entityRGBWeightB, setEntityRGBWeightB] = useState("");

    // 用以取得父節點屬性資料
    useEffect(() => {
        setEnviromentList(props.enviromentList);
        setStartTime(props.startTime);
        setEndTime(props.endTime);
        setShowAllLightning(props.showAllLightning);
    }, [props])

    useEffect(() => {
        if (showAllLightning === null) return;

        if (startTime === null || endTime === null) {
            props.toast.current.show({ severity: 'warn', summary: '警告資訊', detail: '閃電演示區間尚未設定!' });
            props.setShowAllLightning(null);
        } else {
            if (showAllLightning === true) {
                let LightningStartTime = new Date(startTime).getTime();  //每1秒多1,000
                let LightningEndTime = new Date(endTime).getTime();
                let timeEventNum = null;
                let fields = enviromentList;
                let listCount = 0;
                while (fields[listCount]) {
                    if (fields[listCount].play === true) {
                        let LightningOffset = (LightningEndTime - LightningStartTime) / (fields[listCount].period * 1000);
                        let LightningCount = 0;
                        let EventList = timeEventList;
                        let list = [];
                        fields[listCount].play = false;
                        list.push(fields[listCount].number);
                        while (LightningOffset > LightningCount) {
                            timeEventNum = showLightningFun(listCount, LightningStartTime + (fields[listCount].period * 1000) * LightningCount, LightningEndTime);
                            LightningCount++;
                            list.push(timeEventNum);
                        }
                        EventList.push(list);
                        setTimeEventList(EventList);
                        forceUpdate();
                    }
                    listCount++;
                }
            } else {
                let fields = enviromentList;
                let listCount = 0;
                while (fields[listCount]) {
                    fields[listCount].play = true;
                    listCount++;
                }

                timeEventList.map((item) => {

                    let length = item.length;
                    for (let i = 1; i < length; i++) {
                        window.main.OView.removeTimeEvent(item[i]);
                    }
                })
                forceUpdate();
            }
        }

    }, [showAllLightning])

    const dialogFuncMap = {
        'LightningEntity': setLightningEntity,
    }

    const onMenuItemClick = (index) => {
        let field = enviromentList[index];
        switch (field.effect) {
            case "閃電":
                setLightningEntity(true);
                break;
            default:
                break;
        }
    }

    const onHide = (name) => {
        dialogFuncMap[`${name}`](false);
    }

    const fieldgoto = (index) => {
        let field = enviromentList[index];

        let geo3dpoint = new Geo3DPoint(field.param.position);
        let geopoint = new GeoPoint(geo3dpoint.x - 0.03378229630295, geo3dpoint.y - 0.067766758688772, 1366.059043463517);
        let initialV = new Geo3DPoint(0.4576038108900927, 0.8890126321749483, -0.015919964415307384);
        let initialUp = new Geo3DPoint(0.007286201300968689, 0.014155312601379129, 0.9999045715165764);
        let initialCamera = new ov.Camera(geopoint, initialV, initialUp);
        window.main.OView.gotoCamera(initialCamera, true);

    }

    const fieldListRemove = (index) => {

        let fields = enviromentList;
        let field = enviromentList[index];

        timeEventList.map((item) => {
            if (item[0] === field.number) {
                let length = item.length;
                for (let i = 1; i < length; i++) {
                    window.main.OView.removeTimeEvent(item[i]);
                }
            }
        })
        let lightningModule = window.main.OView.getModule("lightning");
        lightningModule.removeAllLightningEntity();
        props.toast.current.show({ severity: 'success', summary: '圖層資訊', detail: '已關閉' + field.effect + '環境特效' });
        fields.splice(index, 1);
        setEnviromentList(fields);
        props.FieldOptionRemove(fields);
        forceUpdate();
    }

    const showLightningFun = (index, LightningStartTime, LightningEndTime) => {

        let field = enviromentList[index];
        let param = null;
        let lightningModule = window.main.OView.getModule("lightning");
        let lightningEntity = null;
        let timeEventNum = null;

        field.param.latitude = reChange ? lastList[0] : entityLatitude ? entityLatitude : field.param.latitude;
        field.param.longitude = reChange ? lastList[1] : entityLongitude ? entityLongitude : field.param.longitude;
        field.param.height = reChange ? lastList[2] : entityHeight ? entityHeight : field.param.height;
        field.param.endHeight = reChange ? lastList[3] : entityEndHeight ? entityEndHeight : field.param.endHeight;
        field.period = reChange ? lastList[4] : entityPeriod ? entityPeriod : field.period;
        field.param.RGBWeightR = reChange ? lastList[5] : entityRGBWeightR ? entityRGBWeightR : field.param.RGBWeightR;
        field.param.RGBWeightG = reChange ? lastList[6] : entityRGBWeightG ? entityRGBWeightG : field.param.RGBWeightG;
        field.param.RGBWeightB = reChange ? lastList[7] : entityRGBWeightB ? entityRGBWeightB : field.param.RGBWeightB;

        timeEventNum = window.main.OView.addTimeEvent({
            start: LightningStartTime,
            end: LightningEndTime,
            onEnter: function () {
                param = {
                    position: new window.Geo3DPoint(parseFloat(field.param.longitude), parseFloat(field.param.latitude), parseFloat(field.param.height)),
                    endHeight: field.param.endHeight,
                    color: new ov.Color([field.param.RGBWeightR, field.param.RGBWeightG, field.param.RGBWeightB]),
                    minWidth: 10,
                    maxWidth: 10,
                    branchMinWidth: 1,
                    branchMaxWidth: 1,
                    completeShowTime: 0.2,
                    completeVanishTime: 0.3,
                    intervalTime: 0.5,
                    splitRate: 0.3,
                    branchSplitRate: 0.3,
                    branchMinGrowTimes: 4,
                    branchMaxGrowTimes: 8
                };
                lightningEntity = lightningModule.addLightningEntity(param);
            },
            onPlay: function (time) {
                if (lightningEntity) {
                    lightningEntity.setTime((time - LightningStartTime) / 1000.0);
                }
            },
            onLeave: function () {
                lightningModule.removeLightningEntity(lightningEntity);
            }
        })

        window.widgetTimelinePlayer.play();

        return timeEventNum;
    }

    const showLightning = (index) => {

        if (startTime === null || endTime === null) {
            props.toast.current.show({ severity: 'warn', summary: '警告資訊', detail: '閃電演示區間尚未設定!' });
        } else {
            let field = enviromentList[index];

            field.play = false;

            let LightningStartTime = new Date(startTime).getTime();  //每1秒多1,000
            let LightningEndTime = new Date(endTime).getTime();
            let LightningOffset = (LightningEndTime - LightningStartTime) / (field.period * 1000);
            let LightningCount = 0;
            let timeEventNum = null;
            let EventList = timeEventList;
            let list = [];

            list.push(field.number);
            while (LightningOffset > LightningCount) {
                timeEventNum = showLightningFun(index, LightningStartTime + (field.period * 1000) * LightningCount, LightningEndTime);
                LightningCount++;
                list.push(timeEventNum);
            }

            EventList.push(list);
            setTimeEventList(EventList);
            forceUpdate();
        }
    }

    const pauseLightning = (index) => {

        let field = enviromentList[index];

        field.play = true;

        timeEventList.map((item) => {
            if (item[0] === field.number) {
                let length = item.length;
                for (let i = 1; i < length; i++) {
                    window.main.OView.removeTimeEvent(item[i]);
                }
            }
        })
        forceUpdate();
    }

    const changeLightning = (index) => {

        let field = enviromentList[index];

        let LightningStartTime = new Date(startTime).getTime();  //每1秒多1,000
        let LightningEndTime = new Date(endTime).getTime();
        let LightningOffset = (LightningEndTime - LightningStartTime) / (field.period * 1000);
        let LightningCount = 0;
        let timeEventNum = null;
        let EventList = timeEventList;
        let list = [];

        if (field.play === false) {
            timeEventList.map((item) => {
                if (item[0] === field.number) {
                    let length = item.length;
                    for (let i = 1; i < length; i++) {
                        window.main.OView.removeTimeEvent(item[i]);
                    }
                }
            })

            let lightningModule = window.main.OView.getModule("lightning");
            lightningModule.removeAllLightningEntity();


            list.push(field.number);
            while (LightningOffset > LightningCount) {
                timeEventNum = showLightningFun(index, LightningStartTime + (field.period * 1000) * LightningCount, LightningEndTime);
                LightningCount++;
                list.push(timeEventNum);
            }

            EventList.push(list);
            setTimeEventList(EventList);
            setReset();
            forceUpdate();
        } else {

            timeEventList.map((item) => {
                if (item[0] === field.number) {
                    let length = item.length;
                    for (let i = 1; i < length; i++) {
                        window.main.OView.removeTimeEvent(item[i]);
                    }
                }
            })

            list.push(field.number);

            field.param.latitude = reChange ? lastList[0] : entityLatitude ? entityLatitude : field.param.latitude;
            field.param.longitude = reChange ? lastList[1] : entityLongitude ? entityLongitude : field.param.longitude;
            field.param.height = reChange ? lastList[2] : entityHeight ? entityHeight : field.param.height;
            field.param.endHeight = reChange ? lastList[3] : entityEndHeight ? entityEndHeight : field.param.endHeight;
            field.period = reChange ? lastList[4] : entityPeriod ? entityPeriod : field.period;
            field.param.RGBWeightR = reChange ? lastList[5] : entityRGBWeightR ? entityRGBWeightR : field.param.RGBWeightR;
            field.param.RGBWeightG = reChange ? lastList[6] : entityRGBWeightG ? entityRGBWeightG : field.param.RGBWeightG;
            field.param.RGBWeightB = reChange ? lastList[7] : entityRGBWeightB ? entityRGBWeightB : field.param.RGBWeightB;

            EventList.push(list);
            setTimeEventList(EventList);
            setReset();
            forceUpdate();
        }


    }

    const storeLastParam = (index) => {
        let field = enviromentList[index];
        let list = [];

        list.push(field.param.latitude);
        list.push(field.param.longitude);
        list.push(field.param.height);
        list.push(field.param.endHeight);
        list.push(field.period);
        list.push(field.param.RGBWeightR);
        list.push(field.param.RGBWeightG);
        list.push(field.param.RGBWeightB);

        setLastList(list);
    }

    const setReset = () => {
        setEntityLatitude("");
        setEntityLongitude("");
        setEntityHeight("");
        setEntityEndHeight("");
        setEntityPeriod("");
        setEntityRGBWeightR("");
        setEntityRGBWeightG("");
        setEntityRGBWeightB("");
        setReChange(false);
    }

    return (
        <div>
            <div>
                {
                    enviromentList.map((item, index) => {
                        return (
                            <div>
                                <div className="field-item">
                                    <div className="field-detail">{index + 1}</div>
                                    <div className="field-detail">{item.effect} {item.count + 1}</div>
                                    <div className="field-action">
                                        {
                                            item.play ?
                                                <Button icon="pi pi-caret-right" className="p-button-rounded p-button-success field-button" onClick={() => { showLightning(index) }} /> :
                                                <Button icon="pi pi-pause" className="p-button-rounded p-button-info field-button" onClick={() => { pauseLightning(index) }} />
                                        }
                                        <Button icon="pi pi-map-marker" className="p-button-rounded field-button" onClick={() => { fieldgoto(index) }} />
                                        <Button icon="pi pi-cog" className="p-button-rounded p-button-warning field-button" onClick={() => { storeLastParam(index); setReset(); onMenuItemClick(index); setIndexNum(index) }} />
                                        <Button icon="pi pi-times" className="p-button-rounded p-button-danger field-button" onClick={() => { fieldListRemove(index) }} />
                                    </div>
                                </div>
                                <Divider />
                            </div>
                        )
                    })
                }
            </div>
            <div className="layout-main-container">
                <LightningEntityOption LightningEntity={LightningEntity} onHide={onHide} indexNum={indexNum} enviromentList={enviromentList} entityLatitude={entityLatitude} setEntityLatitude={setEntityLatitude}
                    entityLongitude={entityLongitude} setEntityLongitude={setEntityLongitude} entityHeight={entityHeight} setEntityHeight={setEntityHeight} entityEndHeight={entityEndHeight}
                    setEntityEndHeight={setEntityEndHeight} entityPeriod={entityPeriod} setEntityPeriod={setEntityPeriod} entityRGBWeightR={entityRGBWeightR} setEntityRGBWeightR={setEntityRGBWeightR} entityRGBWeightG={entityRGBWeightG}
                    setEntityRGBWeightG={setEntityRGBWeightG} entityRGBWeightB={entityRGBWeightB} setEntityRGBWeightB={setEntityRGBWeightB} changeLightning={changeLightning} setReChange={setReChange} />
            </div>
        </div>
    )
}


export const EnviromentEffectComponents = (props) => {

    const [selectType, setSelectType] = useState(null);
    const [enviromentList, setEnviromentList] = useState([]);
    const [fieldGeo, setFieldGeo] = useState(null);
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [color, setColor] = useState("red");
    const [showAllLightning, setShowAllLightning] = useState(null);
    const [TimeSet, setTimeSet] = useState(false);
    const [CloudSet, setCloudSet] = useState(false);

    const [addCloud, setAddCloud] = useState(false);
    const [height, setHeight] = useState(1000);
    const [thickness, setThickness] = useState(250);
    const [densityCutoff, setDensityCutoff] = useState(0.45);
    const [visibleDistance, setVisibleDistance] = useState(50000);
    const [sampling, setSampling] = useState(1);
    const [windSpeedX, setWindSpeedX] = useState(-1);
    const [windSpeedY, setWindSpeedY] = useState(0);


    const [, forceUpdate] = useReducer(num => num + 1, 0);
    const toast = useRef(null);

    // 設定menu
    const dialogFuncMap = {
        'TimeSet': setTimeSet,
        'CloudSet': setCloudSet
    }

    // 點擊目錄開啟對應視窗
    const onMenuItemClick = (name) => {
        dialogFuncMap[`${name}`](true);
    }

    // 點擊關閉紐關閉對應視窗
    const onHide = (name) => {
        dialogFuncMap[`${name}`](false);
    }

    // 若fieldGeo發生變動則呼叫此useEffect
    useEffect(() => {
        if (fieldGeo === null)
            return;
        let param = null;
        let list = [];
        let item = {};
        var count = 0;
        var number = 0;

        // 根據selectType選擇欲添加環境特效 (目前僅有閃電特效)
        switch (selectType) {
            case 0:
                item = {};
                param = {
                    position: new window.Geo3DPoint(fieldGeo.x, fieldGeo.y, 5000),
                    longitude: fieldGeo.x,
                    latitude: fieldGeo.y,
                    height: 5000,
                    endHeight: 0.0,
                    RGBWeightR: 176,
                    RGBWeightG: 255,
                    RGBWeightB: 255
                };
                enviromentList.forEach(item => {
                    if (item.effect === "閃電") {
                        count++;
                    }
                    number++;
                })
                item.param = param;
                item.effect = "閃電";
                item.count = count;
                item.number = number;
                item.play = true;
                item.period = 5; //設定閃電出現週期(次/秒)
                list = enviromentList;
                list.push(item);
                setEnviromentList(list);
                break;
            default:
                break;
        }
    }, [fieldGeo])

    // 透過EventListener取得滑鼠點擊之經緯位置
    const addLightning = () => {
        window.main.OView.addEventListener("InputCompleted", fieldOutput);
        toast.current.show({ severity: 'info', summary: '標註資訊', detail: '請點擊滑鼠左鍵開始增建閃電' });
        window.main.OView.inputSurfacePoint();
    }

    // 若成功取得經緯位置則變更fieldGeo
    const fieldOutput = (event) => {
        if (event.success) {
            setFieldGeo(event.geo);
            forceUpdate();
            window.main.OView.removeEventListener("InputCompleted", fieldOutput);
        }
    }

    useEffect(() => {
        // 用以變更雲層屬性
        let CloudProperty = null;
        let windX = null;
        let windY = null;
        CloudProperty = window.main.OView.cloudProperty;
        windX = parseFloat(windSpeedX);
        windY = parseFloat(windSpeedY);
        CloudProperty.height = parseFloat(height);
        CloudProperty.thickness = parseFloat(thickness);
        CloudProperty.densityCutoff = parseFloat(densityCutoff);
        CloudProperty.visibleDistance = parseFloat(visibleDistance);
        CloudProperty.sampling = parseFloat(sampling);
        CloudProperty.wind = new window.GeoPoint(windX, windY, 0);
        window.main.OView.cloudProperty = CloudProperty;

        if (addCloud) {
            window.main.OView.enableCloud = true;
        } else {
            window.main.OView.enableCloud = false;
            onHide('CloudSet');
        }
    }, [addCloud, windSpeedX, windSpeedY, height, thickness, densityCutoff, visibleDistance, sampling])

    // 若起始時間或結束時間變動則變更時間軸設定
    useEffect(() => {

        if (startTime !== null && endTime !== null) {
            let LightningStartTime = new Date(startTime).getTime();
            let LightningEndTime = new Date(endTime).getTime();

            if (LightningStartTime > LightningEndTime) {
                setEndTime(null);
                return;
            }
            window.widgetTimeline.updateParameter({ startTime: LightningStartTime - 2000, stopTime: LightningEndTime + 2000 });
            window.widgetTimeline.removeAllTimeBlock();
            window.widgetTimeline.addTimeBlock({
                start: LightningStartTime,
                end: LightningEndTime,
                color: 'red'
            });
        }
    }, [startTime, endTime])

    useEffect(() => {
        if (enviromentList.length === 0) {
            setShowAllLightning(null);
            if (window.widgetTimeline) {
                window.widgetTimeline.removeAllTimeBlock();
            }

        }
    }, [enviromentList.length])

    // 移除圖層資料
    const FieldOptionRemove = (layers) => {
        setEnviromentList(layers);
        forceUpdate();
    }

    return (
        <div>
            <div>
                <Toast ref={toast} />
                <Dialog header="環境特效" visible={props.Enviroment} modal={false} keepInViewport={false} onHide={() => props.onHide('Enviroment')}>
                    <Card>
                        <div className="field-item" style={{ width: '95%' }}>
                            <div className="field-object">項次</div>
                            <div className="field-object">項目</div>
                            <div className="field-object">功能</div>
                        </div>
                        <Divider />
                        <div className="scrollpanel-demo">
                            <ScrollPanel style={{ width: '100%', height: '350px' }} className="custombar1">
                                <EnviromentOption enviromentList={enviromentList} FieldOptionRemove={FieldOptionRemove} toast={toast} startTime={startTime} setStartTime={setStartTime} endTime={endTime} setEndTime={setEndTime} showAllLightning={showAllLightning} setShowAllLightning={setShowAllLightning} />
                            </ScrollPanel>
                        </div>
                    </Card>
                    <br></br>
                    <Card>
                        <div className="field grid">
                            <div className="col-12 md:col-4">
                                {
                                    showAllLightning ?
                                        <Button label="暫停所有演示" icon="pi pi-pause" className="p-button-raised" onClick={() => { setShowAllLightning(false) }} style={{ width: "100%" }} /> :
                                        <Button label="演示所有閃電" icon="pi pi-caret-right" className="p-button-raised" onClick={() => { setShowAllLightning(true) }} style={{ width: "100%" }} disabled={enviromentList.length > 0 ? false : true} />
                                }
                            </div>
                            <div className="col-12 md:col-4">
                                <Button label="新增閃電特效" icon="pi pi-plus" className="p-button-raised" onClick={() => { addLightning(); setSelectType(0) }} style={{ width: "100%" }} />
                            </div>
                            <div className="col-12 md:col-4">
                                <Button label="閃電時間設定" icon="pi pi-sliders-h" className="p-button-raised" onClick={() => { onMenuItemClick('TimeSet') }} style={{ width: "100%" }} />
                            </div>
                        </div>
                        <div className="field grid">
                            <div className="col-12 md:col-8">
                                {
                                    addCloud ?
                                        <Button label="移除雲層" icon="pi pi-trash" className="p-button-raised" onClick={() => { setAddCloud(false) }} style={{ width: "100%" }} /> :
                                        <Button label="新增雲層" icon="pi pi-plus" className="p-button-raised" onClick={() => { setAddCloud(true) }} style={{ width: "100%" }} />


                                }
                            </div>
                            <div className="col-12 md:col-4">
                                <Button label="雲層設定" icon="pi pi-sliders-h" className="p-button-raised" onClick={() => { onMenuItemClick('CloudSet') }} style={{ width: "100%" }} />
                            </div>
                        </div>
                        <div>
                            <TimeSetOption TimeSet={TimeSet} onHide={onHide} startTime={startTime} setStartTime={setStartTime} endTime={endTime} setEndTime={setEndTime} color={color} setColor={setColor} />
                            <CloudSetOption CloudSet={CloudSet} onHide={onHide} height={height} setHeight={setHeight} thickness={thickness} setThickness={setThickness} densityCutoff={densityCutoff} setDensityCutoff={setDensityCutoff}
                                visibleDistance={visibleDistance} setVisibleDistance={setVisibleDistance} sampling={sampling} setSampling={setSampling} windSpeedX={windSpeedX} setWindSpeedX={setWindSpeedX} windSpeedY={windSpeedY} setWindSpeedY={setWindSpeedY} />
                        </div>
                    </Card>
                </Dialog>
            </div>

        </div>
    )
}